import { render, staticRenderFns } from "./AddmissionFormWws.vue?vue&type=template&id=fe739228&scoped=true&"
import script from "./AddmissionFormWws.vue?vue&type=script&lang=js&"
export * from "./AddmissionFormWws.vue?vue&type=script&lang=js&"
import style0 from "./AddmissionFormWws.vue?vue&type=style&index=0&id=fe739228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe739228",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSimpleTable})
